import { useEffect, useState } from "react";
import Axios from 'axios';

const RemoveProfilePic=({alimWebToken,alimUserData,profilePicFunc,imgProcessFunc})=>{
    const [haveProfilePic,setHaveProfilePic]=useState(false);

    const checkProfilePic=()=>{
        const userProfilePic=localStorage.alimProfilePic;
        if(userProfilePic!==undefined&&userProfilePic!==null&&userProfilePic!=="no-profile-pic")
        {
            setHaveProfilePic(true);
        }
    }

    const removeUserProfileImg=()=>{
        imgProcessFunc(true);
        Axios.post(`${alimAPIBaseURI}rpc/remove_profile_pic`, {},{headers: {"Content-Type": "application/json","Authorization":`bearer ${alimWebToken}`}}).then((data)=>{
            if(data.data==="Profile image removed")
            {
                profilePicFunc();
                setHaveProfilePic(false);
                localStorage.removeItem("alimProfilePic");
                document.dispatchEvent(profilePicEvent);
            }
        }).catch((error)=>{
            console.log(error);
        }).finally(()=>{
            imgProcessFunc(false);
        });
    }

    useEffect(()=>{
        const profilePicHandler=()=>{
            checkProfilePic();
        }
        document.addEventListener("rem-pro-pic",profilePicHandler);

        return()=>{
            document.removeEventListener("rem-pro-pic", profilePicHandler);
        }
    });

    useEffect(()=>{},[haveProfilePic]);

    useEffect(()=>{
        checkProfilePic();
    },[]);

    if(haveProfilePic)
    {
        return(
            <button className="bg-deep-blue rounded-md px-3 py-2 text-white h-full" onClick={removeUserProfileImg} type="button">Remove profile picture</button>
        )
    }
    else
    {
        return(
            <></>
        )
    }
}

export default RemoveProfilePic;